export const isResultsPage = (location) => location.pathname === "/results";
export const isAdvancedSearch = (location) => location.pathname === "/advanced-search";
export const isAdvancedSearchResults = (location) => location.pathname === "/advanced-results";
export const isMainPage = (location) => location.pathname === "/";
export const isHeadingsSearch = (location) => location.pathname === "/headings-characteristics/search";
export const isFilesSearch = (location) => location.pathname === "/files/search";
export const isRecordsSearch = (location) => location.pathname === "/records/search";
export const isHeadingsDetails = (location) => location.pathname === "/headings/about/details";



// WEBPACK FOOTER //
// ./src/scripts/CheckPathname.js